import SelectionStatus from 'portfolio/components/SelectionStatus';
import React from 'react';

import EstimatedTradeCostHelp from '../help/EstimatedTradeCostHelp';
import { EstimatedTradeCostWidgetSettings } from '../settings/EstimatedTradeCostWidgetSettings';
import WidgetToolbar from 'widgets/WidgetToolbar/WidgetToolbar';
import { useWidgetPortfolioSelectionStatus } from 'widgets/hooks';
import WidgetToolbarShowHidePanel from 'widgets/WidgetToolbarShowHidePanel/WidgetToolbarShowHidePanel';
import { EstimatedTradeCostTitle } from 'widgets/estimatedTradeCost/widget/components/toolbar/EstimatedTradeCostTitle';
import { ToolbarIcon } from '@instinet-analytics/semantic-ui-components';
import { EstimatedTradeCostDebugModal } from '../debug-modal/EstimatedTradeCostDebugModal';
import { StreamMessage } from 'utils/messages/StreamMessage';

export default function EstimatedTradeCostToolbar({
    showRefresh,
    hideSelectionWarning,
    mustShow,
    onRerunQuery,
    messages,
}: {
    hideSelectionWarning: boolean;
    showRefresh: boolean;
    messages: StreamMessage[];
    mustShow: boolean;

    onRerunQuery: () => void;
}) {
    const { hasValidSelection, portfolioSelectionRequirements } =
        useWidgetPortfolioSelectionStatus();

    return (
        <WidgetToolbarShowHidePanel mustShow={!hasValidSelection || mustShow}>
            <div className="EstimatedTradeCostToolbar panel-header">
                <div className="toolbar">
                    <EstimatedTradeCostTitle />

                    {!hideSelectionWarning && (
                        <SelectionStatus
                            widgetName="Pre-Trade Cost Widget"
                            selectionRequirements={
                                portfolioSelectionRequirements
                            }
                        />
                    )}
                </div>
                <WidgetToolbar
                    preceedingItems={<EstimatedTradeCostHelp />}
                    settingsHeader="Pre-Trade Cost Settings"
                    settingsBody={<EstimatedTradeCostWidgetSettings />}
                    settingsClassName="EstimatedTradeCostWidgetSettingsModal"
                    messages={hasValidSelection ? messages : []}
                    fixedItems={
                        <>
                            <EstimatedTradeCostDebugModal />

                            {showRefresh ? (
                                <ToolbarIcon
                                    className="refresh-button"
                                    name="refresh"
                                    tooltip="Refresh"
                                    onClick={onRerunQuery}
                                />
                            ) : undefined}
                        </>
                    }
                />
            </div>
        </WidgetToolbarShowHidePanel>
    );
}
